import { type Clusterzuordnung } from '../dtos';

export const clusterzuordnungLabels = {
  haupttrainer: 'Haupttrainer',
  nebentrainer: 'Nebentrainer',
  ersatztrainer: 'Ersatztrainer',
  weitererTrainer: 'Weitere Trainer',
} as const;

export const printClusterzuordnungLabel = (givenClusterzuordnung: Clusterzuordnung): string =>
  clusterzuordnungLabels[givenClusterzuordnung];
